import NoResults from 'components/no-results/no-results'
import { connectStateResults } from 'react-instantsearch-dom'

const Results = connectStateResults(({ searchResults, children, isSearchStalled }) => {
    if (isSearchStalled) {
        return <div style={{ minHeight: '75vh' }} />
    }
    const show = searchResults && searchResults.nbHits !== 0
    const query = searchResults && searchResults.queryID
    return show ? children : query ? <NoResults /> : null
})

export default Results
